export const APP_STORE_LINK = 'https://apps.apple.com/app/geneva-chat/id1478573199';
export const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.genevachat.prod';

export const ADD_PAID_MEMBERSHIP_LEARN_MORE_URL = '//www.geneva.com/learnmore';

export const HELP_CENTER_URL = 'https://support.bumblebff.com/hc/';

export const SUPPORT_EMAIL = 'support@bumblebff.com';

export const TOWN_RULES_URL = 'https://www.notion.so/genevahq/Town-Rules-67afc70e1b744e7f8456548ee90822a5';
export const GATES_INFO_URL = 'https://www.notion.so/genevahq/Gates-5258f03dcfc54879ba0d207dff351ecb';

export const ZAPIER_LINK_URL = 'http://www.zapier.com';
export const ZAPIER_LEARN_MORE_URL =
  'https://genevahq.notion.site/Using-Geneva-s-Membership-API-4d15db40e9cf448189b9135c2cb1852e';
export const MEMBER_GROUP_LEARN_MORE_URL =
  'https://genevahq.notion.site/Member-Groups-3a10795aa8914d378ed8ff81398329ce';
